export const ID_PLAYER_CONTAINER = 'sbs-main-live-player-area'
export const ID_PLAYER_WRAPPER = 'sbs-main-live-player-wrapper'